export default __webpack_public_path__ + "static/media/pexels-photo-247431Pixabay1000.0220519a.jpeg";